//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.MoveBuilder.js";
import "../CAM/CAM.ExpressionDouble.js";
import "../CAM/CAM.ReferencePoint.js";
import "../CAM/CAM.ProbeControlParametersBuilder.js";
import "../CAM/CAM.ProbeProtectedParametersBuilder.js";
import "../CAM/CAM.ProbeStockParametersBuilder.js";
import "../CAM/CAM.ProbeToleranceParametersBuilder.js";
let d=[[[0,"Angle1",1,0],[0,"Angle2",1,0],[0,"Angle3",1,0],[0,"AngleType",1,0],[0,"ArcVector",1,"NXObject",0],[0,"BossDimension",1,0],[1,"BossDimensionBuilder",0,"CAM.ExpressionDouble",0],[0,"CycleType",1,0],[0,"Cylinder",1,"NXObject",0],[0,"DepthType",1,0],[0,"Diameter",1,0],[1,"DiameterBuilder",0,"CAM.ExpressionDouble",0],[0,"GeometryType",1,0],[0,"MeasurementDepth",1,0],[1,"MeasurementDepthBuilder",0,"CAM.ExpressionDouble",0],[0,"Point",1,"Point",0],[1,"PointBuilder",0,"CAM.ReferencePoint",0],[1,"ProbeControlParameters",0,"CAM.ProbeControlParametersBuilder",0],[1,"ProbeProtectedParameters",0,"CAM.ProbeProtectedParametersBuilder",0],[1,"ProbeStockParameters",0,"CAM.ProbeStockParametersBuilder",0],[1,"ProbeToleranceParameters",0,"CAM.ProbeToleranceParametersBuilder",0]],[],[]];
SPLM.CAM.ProbeInspectBorebossMoveBuilder = class extends SPLM.CAM.MoveBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.ProbeInspectBorebossMoveBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.ProbeInspectBorebossMoveBuilder.Geometry = Object.freeze({
    "Cylinder" : "Cylinder", "Point" : "Point"});

SPLM.CAM.ProbeInspectBorebossMoveBuilder.Cycle = Object.freeze({
    "Bore" : "Bore", "Boss" : "Boss"});

SPLM.CAM.ProbeInspectBorebossMoveBuilder.Angle = Object.freeze({
    "Predefined" : "Predefined", "Custom" : "Custom"});

SPLM.CAM.ProbeInspectBorebossMoveBuilder.Depth = Object.freeze({
    "Midpoint" : "Midpoint", "Specify" : "Specify"});

export default SPLM;